import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDollarUp = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m17.84 14.53 2.137-.615.615 2.136"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9.98 21 2.254-3.635 4.93 1.476 2.815-4.926M12.894 8.221H10.61a1.23 1.23 0 1 0 0 2.46h1.406a1.23 1.23 0 0 1 0 2.462H9.73M11.313 13.141v1.034m0-6.993v1.042"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.215 10.904a7.904 7.904 0 1 0-12.323 6.554"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDollarUp);
export default ForwardRef;
